import React from 'react';
import { useTranslation } from 'react-i18next';
import filledImg from '@/assets/images/filled.webp';
import { Button } from '@/components/Button';
import { Modal } from '@/components/Modal';
import { useSwipeToClose } from '@/hooks/useSwipeToClose';
import { ButtonVariant, ModalVariant, Size } from '@/types/components';

interface Props {
  onClose: () => void;
  onSubmit: () => void;
}

export const SurveySubmitConfirmSheet: React.FC<Props> = ({
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const { sheetRef, swipeProps } = useSwipeToClose(onClose);

  return (
    <Modal
      isOpen
      label={t('mail.surveys.detail.fill.submitTitle')}
      variant={ModalVariant.BottomSheet}
      contentRef={sheetRef}
      onClose={onClose}
    >
      <div
        {...swipeProps}
        className="flex shrink-0 cursor-grab flex-col touch-none active:cursor-grabbing"
      >
        <div className="mx-auto mt-2 h-[3px] w-10 rounded-full bg-drag-handle" />
      </div>

      <div className="flex flex-col items-center gap-4 px-6 pt-2 pb-6 text-center">
        <img
          src={filledImg}
          alt=""
          width={100}
          height={100}
          className="size-[100px]"
        />

        <div className="flex flex-col gap-2">
          <p className="text-title-24 text-foreground">
            {t('mail.surveys.detail.fill.submitTitle')}
          </p>
          <p className="text-body-14 text-subtle-foreground">
            {t('mail.surveys.detail.fill.submitSubtitle')}
          </p>
        </div>
      </div>

      <div className="flex flex-col border-t border-divider px-4 pt-4 pb-[calc(16px+env(safe-area-inset-bottom))]">
        <Button
          variant={ButtonVariant.Primary}
          size={Size.Large}
          className="h-14 w-full"
          onClick={onSubmit}
        >
          {t('mail.surveys.detail.fill.submit')}
        </Button>
      </div>
    </Modal>
  );
};
